import { Injectable } from "@angular/core";
import { PreloadingStrategy, Route } from "@angular/router";
import { catchError, Observable, of } from "rxjs";
import { recoverFromStalePreload } from "./stale-build-reload";

/**
 * `PreloadAllModules` plus recovery when a preloaded chunk has been deleted by
 * a deploy.
 *
 * Preloading every lazy route is not an optimisation here — RouterMenuService
 * builds the sidebar from the children Angular attaches to each route as its
 * chunk loads, and drops any group left with none. So on a tab that predates a
 * deploy, the 404s do not merely fail quietly in the background: entire menu
 * sections go missing and the app looks half-working.
 *
 * Swallowing the error (rather than letting it reject) is deliberate — one
 * dead chunk must not stop the remaining routes from preloading, and the
 * reload, when it happens, supersedes all of it anyway.
 */
@Injectable({ providedIn: "root" })
export class PreloadAllWithStaleBuildRecovery implements PreloadingStrategy {
  preload(_route: Route, load: () => Observable<unknown>): Observable<unknown> {
    return load().pipe(
      catchError((error: unknown) => {
        recoverFromStalePreload(error);
        return of(null);
      }),
    );
  }
}
